import React from "react";

const AspirasiBerandaSkeleton = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* --- Skeleton Cards --- */}
      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Card Skeleton */}
        <div className="bg-white p-6 rounded-lg shadow flex flex-col justify-between animate-pulse">
          <div className="w-full">
            <div className="bg-gray-200 w-12 h-12 rounded-lg mb-2"></div>
          </div>
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
          <div className="h-8 bg-gray-300 rounded w-16"></div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow flex flex-col justify-between animate-pulse">
          <div className="w-full">
            <div className="bg-gray-200 w-12 h-12 rounded-lg mb-2"></div>
          </div>
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
          <div className="h-8 bg-gray-300 rounded w-16"></div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow flex flex-col justify-between lg:col-span-2 animate-pulse">
          <div className="w-full">
            <div className="bg-gray-200 w-12 h-12 rounded-lg mb-2"></div>
          </div>
          <div className="h-4 bg-gray-200 rounded w-1/3 mb-2"></div>
          <div className="h-8 bg-gray-300 rounded w-20"></div>
        </div>
      </div>

      {/* --- Chart Skeleton --- */}
      <div className="bg-white p-6 rounded-lg shadow flex flex-col items-center animate-pulse">
        <div className="h-6 bg-gray-200 w-32 rounded mb-4"></div>
        <div className="w-48 h-48 rounded-full bg-gray-200"></div>
      </div>
    </div>
  );
};

export default AspirasiBerandaSkeleton;
